// extracted by mini-css-extract-plugin
export var advantages__list = "advantages-module--advantages__list--7MWn3";
export var advantages__itemIcon = "advantages-module--advantages__item-icon--eQ2hq";
export var advantages__itemTitle = "advantages-module--advantages__item-title--kK9Dq";
export var advantages__itemDesc = "advantages-module--advantages__item-desc--lE2qP";